import { render, staticRenderFns } from "./debit-card-payment-method.component.vue?vue&type=template&id=0a3c0f3b&"
import script from "./debit-card-payment-method.component.vue?vue&type=script&lang=ts&"
export * from "./debit-card-payment-method.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports